import ScrollWrapper from './scroll-wrapper'

export default ScrollWrapper
